/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const TemplateListDocument = gql`
    query TemplateList($userId: Int) {
  adminTemplateList(userId: $userId) {
    id
    name
    content
    isCommon
    img
    type
  }
}
    `;

/**
 * __useTemplateListQuery__
 *
 * To run a query within a React component, call `useTemplateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTemplateListQuery(baseOptions?: Apollo.QueryHookOptions<TemplateListQuery, TemplateListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateListQuery, TemplateListQueryVariables>(TemplateListDocument, options);
      }
export function useTemplateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateListQuery, TemplateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateListQuery, TemplateListQueryVariables>(TemplateListDocument, options);
        }
// @ts-ignore
export function useTemplateListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TemplateListQuery, TemplateListQueryVariables>): Apollo.UseSuspenseQueryResult<TemplateListQuery, TemplateListQueryVariables>;
export function useTemplateListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateListQuery, TemplateListQueryVariables>): Apollo.UseSuspenseQueryResult<TemplateListQuery | undefined, TemplateListQueryVariables>;
export function useTemplateListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateListQuery, TemplateListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplateListQuery, TemplateListQueryVariables>(TemplateListDocument, options);
        }
export type TemplateListQueryHookResult = ReturnType<typeof useTemplateListQuery>;
export type TemplateListLazyQueryHookResult = ReturnType<typeof useTemplateListLazyQuery>;
export type TemplateListSuspenseQueryHookResult = ReturnType<typeof useTemplateListSuspenseQuery>;
export type TemplateListQueryResult = Apollo.QueryResult<TemplateListQuery, TemplateListQueryVariables>;
export const TemplateShowDocument = gql`
    query TemplateShow($id: Int!) {
  templateShow(id: $id) {
    name
    id
    type
    content
    isCommon
    img
    templateCategory {
      id
      title
    }
    user {
      id
      email
    }
  }
}
    `;

/**
 * __useTemplateShowQuery__
 *
 * To run a query within a React component, call `useTemplateShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateShowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemplateShowQuery(baseOptions: Apollo.QueryHookOptions<TemplateShowQuery, TemplateShowQueryVariables> & ({ variables: TemplateShowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateShowQuery, TemplateShowQueryVariables>(TemplateShowDocument, options);
      }
export function useTemplateShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateShowQuery, TemplateShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateShowQuery, TemplateShowQueryVariables>(TemplateShowDocument, options);
        }
// @ts-ignore
export function useTemplateShowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TemplateShowQuery, TemplateShowQueryVariables>): Apollo.UseSuspenseQueryResult<TemplateShowQuery, TemplateShowQueryVariables>;
export function useTemplateShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateShowQuery, TemplateShowQueryVariables>): Apollo.UseSuspenseQueryResult<TemplateShowQuery | undefined, TemplateShowQueryVariables>;
export function useTemplateShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateShowQuery, TemplateShowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplateShowQuery, TemplateShowQueryVariables>(TemplateShowDocument, options);
        }
export type TemplateShowQueryHookResult = ReturnType<typeof useTemplateShowQuery>;
export type TemplateShowLazyQueryHookResult = ReturnType<typeof useTemplateShowLazyQuery>;
export type TemplateShowSuspenseQueryHookResult = ReturnType<typeof useTemplateShowSuspenseQuery>;
export type TemplateShowQueryResult = Apollo.QueryResult<TemplateShowQuery, TemplateShowQueryVariables>;
export const AddTemplateDocument = gql`
    mutation AddTemplate($content: String!, $name: String!, $isCommon: Boolean!, $type: Int!, $templateCategory: Int!, $user: Int!, $pageId: Int) {
  adminAddTemplate(
    content: $content
    name: $name
    isCommon: $isCommon
    type: $type
    templateCategory: $templateCategory
    user: $user
    pageId: $pageId
  ) {
    id
    type
    content
    isCommon
    img
    user {
      id
      email
      userName
      roles
    }
  }
}
    `;
export type AddTemplateMutationFn = Apollo.MutationFunction<AddTemplateMutation, AddTemplateMutationVariables>;

/**
 * __useAddTemplateMutation__
 *
 * To run a mutation, you first call `useAddTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTemplateMutation, { data, loading, error }] = useAddTemplateMutation({
 *   variables: {
 *      content: // value for 'content'
 *      name: // value for 'name'
 *      isCommon: // value for 'isCommon'
 *      type: // value for 'type'
 *      templateCategory: // value for 'templateCategory'
 *      user: // value for 'user'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useAddTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AddTemplateMutation, AddTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTemplateMutation, AddTemplateMutationVariables>(AddTemplateDocument, options);
      }
export type AddTemplateMutationHookResult = ReturnType<typeof useAddTemplateMutation>;
export type AddTemplateMutationResult = Apollo.MutationResult<AddTemplateMutation>;
export type AddTemplateMutationOptions = Apollo.BaseMutationOptions<AddTemplateMutation, AddTemplateMutationVariables>;
export const UpdateTemplateDocument = gql`
    mutation UpdateTemplate($id: Int!, $name: String!, $content: String!, $isCommon: Boolean!, $type: Int!, $templateCategory: Int!, $user: Int!, $pageId: Int) {
  adminUpdateTemplate(
    id: $id
    name: $name
    content: $content
    isCommon: $isCommon
    type: $type
    templateCategory: $templateCategory
    user: $user
    pageId: $pageId
  ) {
    id
    type
    content
    isCommon
    img
    templateCategory {
      id
      title
      parent
    }
    user {
      id
      email
      userName
      roles
    }
  }
}
    `;
export type UpdateTemplateMutationFn = Apollo.MutationFunction<UpdateTemplateMutation, UpdateTemplateMutationVariables>;

/**
 * __useUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateMutation, { data, loading, error }] = useUpdateTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      content: // value for 'content'
 *      isCommon: // value for 'isCommon'
 *      type: // value for 'type'
 *      templateCategory: // value for 'templateCategory'
 *      user: // value for 'user'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useUpdateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateMutation, UpdateTemplateMutationVariables>(UpdateTemplateDocument, options);
      }
export type UpdateTemplateMutationHookResult = ReturnType<typeof useUpdateTemplateMutation>;
export type UpdateTemplateMutationResult = Apollo.MutationResult<UpdateTemplateMutation>;
export type UpdateTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>;
export const RemoveTemplateDocument = gql`
    mutation RemoveTemplate($id: Int!) {
  adminRemoveTemplate(id: $id)
}
    `;
export type RemoveTemplateMutationFn = Apollo.MutationFunction<RemoveTemplateMutation, RemoveTemplateMutationVariables>;

/**
 * __useRemoveTemplateMutation__
 *
 * To run a mutation, you first call `useRemoveTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTemplateMutation, { data, loading, error }] = useRemoveTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveTemplateMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTemplateMutation, RemoveTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTemplateMutation, RemoveTemplateMutationVariables>(RemoveTemplateDocument, options);
      }
export type RemoveTemplateMutationHookResult = ReturnType<typeof useRemoveTemplateMutation>;
export type RemoveTemplateMutationResult = Apollo.MutationResult<RemoveTemplateMutation>;
export type RemoveTemplateMutationOptions = Apollo.BaseMutationOptions<RemoveTemplateMutation, RemoveTemplateMutationVariables>;
export const RemoveAdminTemplatesDocument = gql`
    mutation RemoveAdminTemplates($ids: [Int!]!) {
  removeAdminTemplates(ids: $ids)
}
    `;
export type RemoveAdminTemplatesMutationFn = Apollo.MutationFunction<RemoveAdminTemplatesMutation, RemoveAdminTemplatesMutationVariables>;

/**
 * __useRemoveAdminTemplatesMutation__
 *
 * To run a mutation, you first call `useRemoveAdminTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdminTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdminTemplatesMutation, { data, loading, error }] = useRemoveAdminTemplatesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRemoveAdminTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAdminTemplatesMutation, RemoveAdminTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAdminTemplatesMutation, RemoveAdminTemplatesMutationVariables>(RemoveAdminTemplatesDocument, options);
      }
export type RemoveAdminTemplatesMutationHookResult = ReturnType<typeof useRemoveAdminTemplatesMutation>;
export type RemoveAdminTemplatesMutationResult = Apollo.MutationResult<RemoveAdminTemplatesMutation>;
export type RemoveAdminTemplatesMutationOptions = Apollo.BaseMutationOptions<RemoveAdminTemplatesMutation, RemoveAdminTemplatesMutationVariables>;
export type TemplateListQueryVariables = Types.Exact<{
  userId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type TemplateListQuery = { __typename?: 'Query', adminTemplateList: Array<{ __typename?: 'GraphTemplate', id?: number | null, name?: string | null, content?: string | null, isCommon?: boolean | null, img?: string | null, type?: number | null }> };

export type TemplateShowQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type TemplateShowQuery = { __typename?: 'Query', templateShow: { __typename?: 'GraphTemplate', name?: string | null, id?: number | null, type?: number | null, content?: string | null, isCommon?: boolean | null, img?: string | null, templateCategory?: { __typename?: 'GraphTemplateCategory', id?: number | null, title?: string | null } | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null } };

export type AddTemplateMutationVariables = Types.Exact<{
  content: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
  isCommon: Types.Scalars['Boolean']['input'];
  type: Types.Scalars['Int']['input'];
  templateCategory: Types.Scalars['Int']['input'];
  user: Types.Scalars['Int']['input'];
  pageId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type AddTemplateMutation = { __typename?: 'Mutation', adminAddTemplate: { __typename?: 'GraphTemplate', id?: number | null, type?: number | null, content?: string | null, isCommon?: boolean | null, img?: string | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, userName: string, roles: Array<string> } | null } };

export type UpdateTemplateMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  name: Types.Scalars['String']['input'];
  content: Types.Scalars['String']['input'];
  isCommon: Types.Scalars['Boolean']['input'];
  type: Types.Scalars['Int']['input'];
  templateCategory: Types.Scalars['Int']['input'];
  user: Types.Scalars['Int']['input'];
  pageId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UpdateTemplateMutation = { __typename?: 'Mutation', adminUpdateTemplate: { __typename?: 'GraphTemplate', id?: number | null, type?: number | null, content?: string | null, isCommon?: boolean | null, img?: string | null, templateCategory?: { __typename?: 'GraphTemplateCategory', id?: number | null, title?: string | null, parent?: number | null } | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, userName: string, roles: Array<string> } | null } };

export type RemoveTemplateMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type RemoveTemplateMutation = { __typename?: 'Mutation', adminRemoveTemplate: boolean };

export type RemoveAdminTemplatesMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
}>;


export type RemoveAdminTemplatesMutation = { __typename?: 'Mutation', removeAdminTemplates: boolean };
